import React from 'react';
class DashboardPage extends React.Component {

    render() {

    }
}
export default DashboardPage;


// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardPage.js